import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import FifthWheelHistory from './fifth-wheel-history';
import FifthWheelHistoryDetail from './fifth-wheel-history-detail';
import FifthWheelHistoryUpdate from './fifth-wheel-history-update';
import FifthWheelHistoryDeleteDialog from './fifth-wheel-history-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={FifthWheelHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={FifthWheelHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={FifthWheelHistoryDetail} />
      <ErrorBoundaryRoute path={match.url} component={FifthWheelHistory} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={FifthWheelHistoryDeleteDialog} />
  </>
);

export default Routes;
